import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';

export default class ColorPickerViewModel extends ControlViewModel {

    /**
     * Der Wert des Color-Pickers
     */
    public value: KnockoutObservable<string>;

    /**
     * Gibt an, ob es sich bei dem Wert um einen Hexadezimalwert handelt
     */
    public isHexValue: boolean;

    /**
     * Gibt an, ob der Wert mit Opacity angegeben ist
     */
    public hasOpacity: boolean;

    /**
     * Der Farb-Wert des Color-Pickers
     */
    public color: KnockoutComputed<string>;

    /**
     * Das ViewModel fuer den ColorPicker
     * @param {object} params - Ein Objekt mit Optionen f�r das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.value = this.observableOrDefault(params.value, null);
        this.isHexValue = this.paramOrDefault(params.isHexValue, false);
        this.hasOpacity = this.paramOrDefault(params.hasOpacity, true);

        this.color = this.definePureComputed({
            read: () => {
                let value = this.value();

                if (value) {
                    this.isHexValue = value.indexOf('#') > -1;
                    this.hasOpacity = this.isHexValue ? value.length === 9 : value.length === 8;

                    let color = value.substring(value.length - 6);

                    return color;
                } else {
                    this.isHexValue = true;
                    this.hasOpacity = false;

                    return '#ffffff';
                }
            },
            write: (value: string) => {
                let prefix = '';
                let opacity = '';

                if (this.isHexValue === true) {
                    prefix = '#';
                }

                if (this.hasOpacity === true) {
                    opacity = 'FF';
                }

                if (!value) {
                    value = 'FF';
                } else {
                    value = value.replace('#', '');
                }

                value = prefix + opacity + (value.toUpperCase());
                this.value(value);
            }
        });
    }
}

ComponentManager.setViewModel('ColorPickerViewModel', ColorPickerViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');